import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../../atoms/buttons/enums.js';
import { wrapRichTextTables } from '../../../utilities/dom-helpers/index.js';
import '../../../atoms/buttons/generic-button2.0/index.js';
import '../../../molecules/image-block-container/index.js';

const renderBadge = (badge) => $ `<p class="feature-card__badge">${badge}</p>`;
const renderFeatureCard = (card, index) => {
    var _a;
    const cardId = `feature-card-${card.id || index}`;
    const titleId = `${cardId}-title`;
    const descId = `${cardId}-desc`;
    const ctaAriaLabel = card.ctaAriaLabel || undefined;
    const ctaTarget = card.ctaTarget || '_self';
    const badgesTemplate = card.badges && card.badges.length > 0
        ? $ `<div class="feature-card__badges">${card.badges.map(renderBadge)}</div>`
        : w;
    const ariaAttributes = {
        'aria-label': ctaAriaLabel,
        'aria-describedby': descId,
    };
    card.ctaLabel
        ? $ `<generic-button-updated type="primary" color="purple" styleType="light" appearance="default" label="${card.ctaLabel}" href="${card.ctaHref}" target="${ctaTarget}" .ariaList="${ariaAttributes}" .isNoFollow="${(_a = card.ctaNoFollow) !== null && _a !== void 0 ? _a : false}"></generic-button-updated>`
        : w;
    return $ `<article class="feature-card" id="${cardId}" data-card-index="${index}"><div class="feature-card__content">${badgesTemplate}<h3 id="${titleId}" class="feature-card__title">${card.title}</h3><div id="${descId}" class="feature-card__description rte">${o(wrapRichTextTables(card.description))}</div><div class="feature-card__cta-group"><generic-button-updated type="primary" color="purple" styleType="light" appearance="default" label="${card.ctaLabel}" href="${card.ctaHref}" target="${ctaTarget}" .ariaList="${ariaAttributes}"></generic-button-updated></div></div><div class="feature-card__image-wrapper"><image-block-container src="${card.imageUrl}" alt="${card.imageAltText}" decorative="${card.imageDecorative ? 'decorative' : ''}" alignment="left" full-width></image-block-container></div></article>`;
};

export { renderFeatureCard };
